import React, { useMemo, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme, useMediaQuery } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EditIcon from "@mui/icons-material/Edit";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import HomeIcon from "@mui/icons-material/Home";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt1";
import PersonRemoveAlt1Icon from "@mui/icons-material/PersonRemoveAlt1";
import CasesRoundedIcon from "@mui/icons-material/CasesRounded";
import GroupIcon from "@mui/icons-material/Group";
import VerifiedIcon from "@mui/icons-material/Verified";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Restricted from "components/Restricted";
import clienteAxios from "../../config/clienteAxios";
import axios from "axios";
import { useGetUsuariosQuery } from "state/api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: 5,
  p: 4,
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AgregarMiembros = () => {
  const location = useLocation();
  const [ejecutar, setEjecutar] = React.useState(true);
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const proyect = JSON.parse(id);
  const [user, setUser] = React.useState([]);
  const [userDisponible, setUserDisponible] = React.useState([]);
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const userS = async () => {
    try {
      const { data1 } = await axios
        .get("/usuariosequipos", {
          params: {
            id: proyect.id,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          let datos = response.data;
          let datosDisponible = datos.filter(
            (dato) => dato.equiposA == "Disponible"
          );
          datos = datos.filter((dato) => dato.equiposA == "Asignado");

          setUser(datos);
          setUserDisponible(datosDisponible);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  if (ejecutar) {
    userS();
  }
  const nav = useNavigate();

  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //Modal Handlers
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Theme
  const theme = useTheme();

  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //DropDown Button
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropDown = Boolean(anchorEl);
  const handleDropDown = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseDropDown = () => {
    setAnchorEl(null);
  };

  //Alerts Handlers
  const [openNoti, setOpenNoti] = React.useState(false);
  const [openNotiError, setOpenNotiError] = React.useState(false);

  //Routes
  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };

  const handleLinkProjects = (event, message) => {
    if (message === "proyectos") {
      nav("/proyectos");
    }
  };

  const handleLinkAdmin = (event, message) => {
    if (message === "administrar") {
      nav("/adminEquipos");
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "nombres",
        header: "Nombre",
      },
      {
        accessorKey: "apellidos",
        header: "Apellido",
      },
      {
        accessorKey: "descripcion",
        header: "Ocupación",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "equiposA",
        header: "Estado",
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={{
              backgroundColor:
                cell.getValue() === "Asignado" ? "green" : "darkorange",
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "9ch",
              p: "0.25rem",
            }}
          >
            {cell.getValue()}
          </Box>
        ),
      },
    ],
    []
  );

  const handleSubmit = async (dato) => {
    console.log(dato);
    try {
      const { data1 } = await axios
        .put("/asignarequipo", {
          correo: dato.original.email,
          equipo: proyect.id,
        })
        .then(function (response) {
          // setAlerta({})
          //console.log(response.data.idToken)
          //localStorage.setItem('token',JSON.stringify(response.data) )
          //setAuth(data)
          setEjecutar(true);
          setOpenNoti(true);
          setTimeout(() => {
            setOpenNoti(false);
          }, 2000);
        })
        .catch(function (error) {
          console.log("error");
          // document.getElementById(":r7:").value='';
        });

      //setOpen(false);
    } catch (error) {}
  };
  const handleEliminar = async (dato) => {
    console.log(dato);
    try {
      const { data1 } = await axios
        .put("/asignarequipo", {
          correo: dato.original.email,
          equipo: 0,
        })
        .then(function (response) {
          // setAlerta({})
          //console.log(response.data.idToken)
          //localStorage.setItem('token',JSON.stringify(response.data) )
          //setAuth(data)
          setEjecutar(true);
          setOpenNotiError(true);
          setTimeout(() => {
            setOpenNotiError(false);
          }, 2000);
        })
        .catch(function (error) {
          console.log("error");
          // document.getElementById(":r7:").value='';
        });

      //setOpen(false);
    } catch (error) {}
  };

  //Tabs Handlers
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChangeTabs = (event, newValueTabs) => {
    setValueTabs(newValueTabs);
  };

  if (user === "")
    return (
      <Container component="main" maxWidth="xs">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    );

  return (
    <Box m="1.5rem 2.5rem">
      {rol === "1" ||
      rol === "2" ||
      rol === "6" ||
      rol === "7" ||
      rol === "10" ? (
        <>
          <Collapse in={openNoti}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNoti(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡ Miembro(s) Agregado(s) !
            </Alert>
          </Collapse>
          <Collapse in={openNotiError}>
            <Alert
              variant="filled"
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNotiError(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡ Miembro(s) Removido(s) !
            </Alert>
          </Collapse>
          <Box
            role="presentation"
            onClick={handleClickBreadCrumbs}
            sx={{ mb: 3 }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/inicio"
                onClick={(event) => handleLinkHome(event, "home")}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Inicio
              </Link>
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/proyectos"
                onClick={(event) => handleLinkProjects(event, "proyectos")}
              >
                <CasesRoundedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Proyectos
              </Link>
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/adminEquipos"
                onClick={(event) => handleLinkAdmin(event, "administrar")}
              >
                <GroupIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Administrar Equipos
              </Link>
              <Typography
                sx={{ display: "flex", alignItems: "center" }}
                color="text.primary"
              >
                <GroupAddIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Agregar Miembros
              </Typography>
            </Breadcrumbs>
            <Typography variant="h3" sx={{ mt: 2 }}>
              <b>Agregar Miembros:</b> {proyect.nombre}
            </Typography>
          </Box>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            p="1rem 1rem"
            flex="1 1 100%"
            borderRadius="0.55rem"
          >
            <CssBaseline />
            <Container>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    variant="h4"
                    component="div"
                    sx={{ mb: 2, fontWeight: "bold" }}
                  >
                    Crear Equipo
                  </Typography>
                  <Divider />
                  <Grid container spacing={2} mt={2} mb={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="nombreEquipo"
                        required
                        fullWidth
                        id="nombreEquipo"
                        label="Nombre de Equipo"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        type="number"
                        id="miembros"
                        label=" Cantidad de Miembros"
                        name="miembros"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        required
                        fullWidth
                        id="descripcion"
                        label="Descripción"
                        name="descripcion"
                      />
                    </Grid>
                  </Grid>
                  <Divider />
                  <Grid
                    container
                    sx={{ mt: 2 }}
                    spacing={1}
                    justifyContent="center"
                  >
                    <Grid item sm={6} xs={6}>
                      <Button
                        variant="contained"
                        color="error"
                        size="large"
                        fullWidth
                        onClick={handleClose}
                      >
                        Cancelar
                      </Button>
                    </Grid>
                    <Grid item sm={6} xs={6}>
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        size="large"
                        fullWidth
                      >
                        Guardar
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
              <Box
                gridColumn="span 8"
                gridRow="span 3"
                backgroundColor={theme.palette.background.alt}
                p="1.5rem"
                borderRadius="1.5rem"
                mt="5px"
                height="fit-content"
                sx={{ boxShadow: 4 }}
              >
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={valueTabs}
                      onChange={handleChangeTabs}
                      variant={isSmallScreen ? "scrollable" : "fullWidth"}
                      scrollButtons
                      allowScrollButtonsMobile
                    >
                      <Tab
                        icon={<VerifiedIcon />}
                        iconPosition="start"
                        label="Voluntarios Asignados"
                        {...a11yProps(0)}
                      />
                      <Tab
                        icon={<PersonSearchIcon />}
                        iconPosition="start"
                        label="Voluntarios Disponibles"
                        {...a11yProps(1)}
                      />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={valueTabs} index={0}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                          Listado de Voluntarios Asignados
                        </Typography>
                      </Grid>
                    </Grid>
                    <MaterialReactTable
                      columns={columns}
                      data={user}
                      localization={MRT_Localization_ES}
                      enableRowActions
                      enableRowSelection
                      positionActionsColumn="last"
                      muiTablePaperProps={{
                        elevation: 0,
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      renderTopToolbarCustomActions={({ table }) => {
                        const handleRemove = () => {
                          table.getSelectedRowModel().flatRows.map((row) => {
                            /*alert('Agregado: ' + row.getValue('nombres'));*/
                            handleEliminar(row);
                          });
                        };
                        console.log(table.getIsAllRowsSelected())
                        return (
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <Button
                              color="error"
                              hidden={!table.getIsSomeRowsSelected() ? !table.getIsAllRowsSelected() : table.getIsAllRowsSelected()}
                              variant="contained"
                              onClick={handleRemove}
                            >
                              <PersonRemoveAlt1Icon sx={{ mr:1 }} /> Remover
                           </Button>
                          </div>
                        );
                      }}
                      renderRowActionMenuItems={({ closeMenu, row }) => [
                        <MenuItem
                          key="edit"
                          onClick={(event) => {
                            handleSubmit(row);
                            closeMenu();
                          }}
                          style={{
                            display:
                              row.getValue("equiposA") === "Disponible"
                                ? "block"
                                : "none",
                          }}
                        >
                          <PersonAddAltIcon sx={{ mr: 1 }} />
                          <b> Asignar Miembro </b>
                        </MenuItem>,
                        <MenuItem
                          key="delete"
                          onClick={(event) => {
                            handleEliminar(row);
                            closeMenu();
                          }}
                          sx={{ color: "#FF6347", fontWeight: "bold" }}
                          style={{
                            display:
                              row.getValue("equiposA") === "Asignado"
                                ? "block"
                                : "none",
                          }}
                        >
                          <PersonRemoveAlt1Icon sx={{ mr: 1 }} /> Remover Miembro
                        </MenuItem>,
                      ]}
                      muiTopToolbarProps={{
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      muiTableHeadCellProps={{
                        align: "center",
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      muiBottomToolbarProps={{
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      muiTableBodyProps={{
                        sx: {
                          "& tr:nth-of-type(odd)": {
                            backgroundColor: theme.palette.background.light,
                          },
                        },
                      }}
                      muiTableBodyCellProps={{
                        align: "center",
                      }}
                      initialState={{
                        pagination: {
                          pageSize: 5,
                          pageIndex: 0,
                        },
                      }}
                      muiTablePaginationProps={{
                        rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                        showFirstButton: false,
                        showLastButton: false,
                        SelectProps: {
                          native: true,
                        },
                        labelRowsPerPage: "Número de filas visibles",
                      }}
                    />
                  </CustomTabPanel>
                  <CustomTabPanel value={valueTabs} index={1}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                          Listado de Voluntarios Disponibles
                        </Typography>
                      </Grid>
                    </Grid>
                    <MaterialReactTable
                      columns={columns}
                      data={userDisponible}
                      localization={MRT_Localization_ES}
                      enableRowActions
                      enableRowSelection
                      positionActionsColumn="last"
                      renderTopToolbarCustomActions={({ table }) => {
                        const handleAdd = () => {
                          table.getSelectedRowModel().flatRows.map((row) => {
                            /*alert('Agregado: ' + row.getValue('nombres'));*/
                            handleSubmit(row);
                          });
                        };

                        return (
                          <div style={{ display: "flex", gap: "0.5rem" }}>
                            <Button
                              color="success"
                              hidden={!table.getIsSomeRowsSelected() ? !table.getIsAllRowsSelected() : table.getIsAllRowsSelected() }
                              variant="contained"
                              onClick={handleAdd}
                            >
                              <PersonAddAltIcon sx={{ mr: 1 }} /> Asignar
                            </Button>
                          </div>
                        );
                      }}
                      muiTablePaperProps={{
                        elevation: 0,
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      renderRowActionMenuItems={({ closeMenu, row }) => [
                        <MenuItem
                          key="edit"
                          onClick={(event) => {
                            handleSubmit(row);
                            closeMenu();
                          }}
                          style={{
                            display:
                              row.getValue("equiposA") === "Disponible"
                                ? "block"
                                : "none",
                          }}
                        >
                          <PersonAddAltIcon sx={{ mr: 1 }} />
                          <b> Asignar Miembro </b>
                        </MenuItem>,
                        <MenuItem
                          key="delete"
                          onClick={(event) => {
                            handleEliminar(row);
                            closeMenu();
                          }}
                          sx={{ color: "#FF6347", fontWeight: "bold" }}
                          style={{
                            display:
                              row.getValue("equiposA") === "Asignado"
                                ? "block"
                                : "none",
                          }}
                        >
                          <PersonRemoveAlt1Icon sx={{ mr: 1 }} /> Quitar Miembro
                        </MenuItem>,
                      ]}
                      muiTopToolbarProps={{
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      muiTableHeadCellProps={{
                        align: "center",
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      muiBottomToolbarProps={{
                        sx: {
                          backgroundColor: theme.palette.background.alt,
                        },
                      }}
                      muiTableBodyProps={{
                        sx: {
                          "& tr:nth-of-type(odd)": {
                            backgroundColor: theme.palette.background.light,
                          },
                        },
                      }}
                      muiTableBodyCellProps={{
                        align: "center",
                      }}
                      initialState={{
                        pagination: {
                          pageSize: 5,
                          pageIndex: 0,
                        },
                      }}
                      muiTablePaginationProps={{
                        rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                        showFirstButton: false,
                        showLastButton: false,
                        SelectProps: {
                          native: true,
                        },
                        labelRowsPerPage: "Número de filas visibles",
                      }}
                    />
                  </CustomTabPanel>
                </Box>
              </Box>
            </Container>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default AgregarMiembros;
